// extracted by mini-css-extract-plugin
export var container = "_ig-0";
export var outlet = "_ig-1";
export var outletEnter = "_ig-2";
export var outletEnterActive = "_ig-3";
export var outletExit = "_ig-4";
export var outletExitActive = "_ig-5";